<div class="center">
    <mat-card id = "style-4" class="cardcomponentMasks">
        <div class="arx-calendar">
            <iframe width="1500" height="800" src="https://app.powerbi.com/view?r=eyJrIjoiNjdhNmVjMDktMzAyZi00ZWRiLWJlYmYtYTJlYWNiNjk1NjgxIiwidCI6IjMyZjEwMmZlLTQ3MTgtNGJlMS1hNWMzLTIxNzAyOTkwOTA1NCIsImMiOjl9" frameborder="0" allowfullscreen="true"></iframe>
        </div>
    </mat-card>
</div>


